module.exports = __webpack_public_path__ + "img/republic-of-poland.ed9d5529.svg";